<!-- 储值卡代付查询 -->
<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    closeable
    @close="close"
    :style="{ height: '50%' }"
    :safe-area-inset-bottom="true"
  >
    <div class="stored-card-search-popup">
      <div class="title">其他储值卡代付</div>
      <template v-if="step == 1">
        <div class="search-bar">
          <van-search v-model="searchPhone" show-action placeholder="请输入持卡人完整手机号" @search="onSearch">
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
        <div class="more-wrapper">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="more-item van-hairline--bottom"
            :class="{ 'is-expire': item.status == 2 }"
          >
            <div class="flex-between">
              <div class="left van-ellipsis">
                {{ item.storedCardAccountName }}<span v-if="item.status == 2">(已过期)</span>
              </div>
              <div class="right">
                余额：<span class="red">￥{{ item.allTotalMoney | formatNumber }}</span>
              </div>
            </div>
            <div class="bottom">持卡人：{{ item.storedCardName }}</div>
          </div>
        </div>
        <page-footer-btn multipleBtns v-if="isShowBtn">
          <van-button square round block type="primary" @click="toConfirm">确定代付</van-button>
        </page-footer-btn>
      </template>
      <template v-if="step == 2">
        <div class="title1">
          输入持卡人手机号收到的验证码，验证通过后，即可使用这张未绑定的储值卡进行本次支付（仅本次支付有效）。
        </div>
        <div class="more-wrapper">
          <div class="input-line">
            <input
              type="tel"
              placeholder="请输入手机号码"
              v-model="searchPhone"
              maxlength="11"
              readonly
            />
            <!-- <i class="vxs-icon vxs-icon-qingchu" v-if="phone" @click.stop="phone = ''"></i> -->
          </div>
          <div class="input-line">
            <input
              type="tel"
              ref="codeInput"
              maxlength="4"
              v-model="smsCode"
              placeholder="请输入验证码"
            />
            <p class="reget-code">
              <van-count-down
                ref="getCodeCountDown"
                millisecond
                v-if="showGetCodeCountDown"
                :time="60 * 1000"
                auto-start
                format="重新获取(ss)"
                @finish="countDownFinish"
              />
              <span v-else @click="getCodeVerify">
                {{ getCodedStatus === 'never' ? '获取验证码' : '重新获取' }}
              </span>
            </p>
          </div>
        </div>
        <page-footer-btn multipleBtns>
          <van-button square round block @click="reset2">返回</van-button>
          <van-button square round block type="primary" @click="dosomething">确认</van-button>
        </page-footer-btn>
      </template>
    </div>
  </van-popup>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  data() {
    return {
      show: false,
      searchPhone: '',
      list: [],
      step: 1,
      isSending: false,

      // phone: '',
      smsCode: '',
      // 获取验证码状态，never从未获取，once 获取过一次
      getCodedStatus: 'never',
      showGetCodeCountDown: false,
      storedCardAccountList: []
    };
  },
  computed: {
    isShowBtn() {
      // 查询结果中，有状态正常且余额大于0的储值卡，则展示“确认代付”按钮
      let arr = this.list.filter(v => v.status == 0 && v.allTotalMoney > 0);
      return arr.length > 0;
    },
  },
  methods: {
    onSearch() {
      if (!this.searchPhone) {
        return vant.Toast('请输入手机号');
      } else if (!/^\d{11}$/.test(this.searchPhone)) {
        return vant.Toast('手机号格式不正确');
      } else {
        this.getAccountAndStudentsBysearchPhone();
      }
    },
    async getAccountAndStudentsBysearchPhone() {
      this.showLoading();
      let res = await this.$api.getStoredCardAccounts({
        storedCardPhone: this.searchPhone.trim(),
        storedCardNo: '',
        storedCardAccountId: '',
      });
      this.$toast.clear();
      this.list = res.data;
      if (res.data.length == 0) {
        this.$toast('暂无数据');
      }
    },
    hasIntersection(arr1, arr2) {
      return arr1.filter(item => arr2.includes(item)).length > 0;
    },
    toConfirm() {
      let arr1 = this.list.map(v=> v.id);
      let arr2 = this.storedCardAccountList.map(v=> v.id);
      if (this.hasIntersection(arr1, arr2)) {
        return this.$toast.fail('此手机号的储值卡已添加');
      }
      this.step = 2;
    },
    open({ list }) {
      this.reset();
      this.show = true;
      this.storedCardAccountList = list;

      return new Promise((rsv, rej) => {
        this._rsv = rsv;
        this._rej = rej;
      });
    },
    close() {
      this._rej && this._rej();
    },
    reset() {
      this.searchPhone = '';
      this.list = [];
      this.reset2();
    },
    reset2() {
      this.step = 1;
      this.smsCode = '';
      this.getCodedStatus = 'never';
      this.showGetCodeCountDown = false;
    },
    // 倒计时完成，获取验证码设置为可用
    countDownFinish() {
      this.showGetCodeCountDown = false;
    },
    async getCodeVerify() {
      if (!/^\d{11}$/.test(this.searchPhone.trim())) {
        this.$toast('请输入正确的手机号码');
        return;
      }
      this.showLoading();
      let res = await this.$api.sendStoredCardSmsCode({
        phone: this.searchPhone.trim(),
      });
      this.$toast.clear();
      if (res.code === 200) {
        this.$toast.success('发送成功');
        // 发送成功，重新倒计时(考虑重新获取)
        this.showGetCodeCountDown = true;
        this.$refs.codeInput.focus();
        // this.pcode = res.data;
      } else {
        this.$toast.fail(res.msg);
      }
    },
    async dosomething() {
      if (!this.smsCode.trim()) {
        this.$toast("请输入验证码");
        return;
      }
      this.showLoading();
      let res = await this.$api.verifyStoredCardSmsCode({
        phone: this.searchPhone.trim(),
        smsCode: this.smsCode.trim()
      });
      this.$toast.clear();
      if (res.code === 200) {
        this._rsv &&
          this._rsv({
            data: this.list.map(v=> {
              return {
                ...v,
                isOther: true,
                verifyPhone: this.searchPhone.trim(),
                verifyCode: res.data,
                isChecked: false,
                money: 0
              }
            }),
          });
        this.show = false;
      } else {
        this.$toast.fail(res.msg);
      }
    },
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.stored-card-search-popup {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.title {
  height: 44px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--g8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}
.title1 {
  padding: calc(var(--gap) * 12) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
  color: var(--g6);
}
.search-bar {
  padding-right: calc(var(--gap) * 16);
}
.more-wrapper {
  overflow: auto;
  flex: 1 1 auto;
  .more-item {
    padding: 6px 16px;
    // height: 50px;
    &.is-expire {
      color: var(--g6) !important;
    }
    .left {
      flex: 1;
      font-weight: bold;
      color: var(--g8);
    }
    .right {
      width: 130px;
      text-align: right;
      .red {
        color: var(--c3);
      }
    }
    .bottom {
      margin-top: calc(var(--gap) * 2);
      color: var(--g6);
    }
  }
  .input-line {
    margin: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 16);
    display: flex;
    align-items: center;
    height: 46px;
    background: var(--g1);
    border-radius: var(--radius-sm);
    .vxs-icon {
      margin-right: calc(var(--gap) * 16);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      color: var(--g5);
    }
    .reget-code {
      box-sizing: border-box;
      margin: 0;
      min-width: 95px;
      height: 22px;
      border-left: 1px solid var(--g3);
      white-space: nowrap;
      padding-left: 8px;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--c1);
    }
    input {
      padding: 0 calc(var(--gap) * 16);
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      color: var(--black);
      box-shadow: unset;
      border: unset;
      line-height: 1;
      font-size: var(--fs-lg);
      background: var(--g1);
      outline: unset;
      border-radius: var(--radius-sm);
      &::placeholder {
        color: var(--g5);
        padding-top: 3px;
      }
    }
  }
  .van-count-down {
    color: var(--g5);
  }
}
</style>